import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "@store/api/baseQueries";

export const activitiesApi = createApi({
  reducerPath: "activitiesApi",
  baseQuery: customBaseQuery(
    fetchBaseQuery({
      baseUrl: `${process.env.REACT_APP_ZOOMAPP_BACKEND_BASE_URL}/activities`,
    })
  ),
  tagTypes: ["Activity"],
  endpoints: (builder) => {
    return {
      createActivity: builder.mutation({
        query: (body) => ({
          url: `/`,
          method: "POST",
          body,
        }),
      }),
      updateActivity: builder.mutation({
        query: ({ activityId, body }) => ({
          url: `/${activityId}`,
          method: "PUT",
          body,
        }),
        invalidatesTags: ["Activity"],
      }),
      deleteActivity: builder.mutation({
        query: (activityId) => ({
          url: `/${activityId}`,
          method: "DELETE",
        }),
      }),
      getActivities: builder.query({
        query: (query) => ({
          url: `/`,
          method: "GET",
          params: query,
        }),
        providesTags: ["Activity"],
      }),
      goLive: builder.mutation({
        query: (id) => ({
          url: `/${id}/live`,
          method: "PUT",
        }),
      }),
      stopLive: builder.mutation({
        query: (id) => ({
          url: `/${id}/stop`,
          method: "PUT",
        }),
      }),
      respondToActivity: builder.mutation({
        query: ({ id, body }) => ({
          url: `/${id}/respond`,
          method: "PUT",
          body,
        }),
      }),
      viewActivity: builder.mutation({
        query: ({ id }) => ({
          url: `/${id}/view`,
          method: "PUT",
        }),
      }),
      remixActivity: builder.mutation({
        query: ({ activityId, body }) => ({
          url: `/${activityId}/remix`,
          method: "POST",
          body,
        }),
        invalidatesTags: ["Activity"],
      }),
    };
  },
});

export const {
  useRespondToActivityMutation,
  useViewActivityMutation,
  useGetActivitiesQuery,
  useGoLiveMutation,
  useStopLiveMutation,
  useCreateActivityMutation,
  useUpdateActivityMutation,
  useDeleteActivityMutation,
  useRemixActivityMutation,
} = activitiesApi;
